export const categoryDetailsHU = {
  brakes: {
    title: 'Fékkomponensek minden járműhöz',
    intro: 'Kiváló minőségű féktárcsák, fékbetétek és komplett fékrendszerek a maximális biztonság érdekében.',
    content: `
      <h3>Miért olyan fontosak a minőségi fékek?</h3>
      <p>A fékrendszer a járműve legfontosabb biztonsági eleme. Az elhasználódott vagy gyenge minőségű fékkomponensek veszélyes helyzetekhez vezethetnek. Az Autoteile Flottnál csak ellenőrzött márkaminőséget kínálunk, amely megfelel a legmagasabb biztonsági szabványoknak.</p>
      
      <h3>Fékkomponenseink áttekintése</h3>
      <ul>
        <li><strong>Féktárcsák:</strong> Perforált és hornyolt változatok az optimális fékteljesítményhez</li>
        <li><strong>Fékbetétek:</strong> Organikus és fém változatok különböző vezetési stílusokhoz</li>
        <li><strong>Fékfolyadék:</strong> DOT 3, DOT 4 és DOT 5.1 minden követelményhez</li>
        <li><strong>Féknyergek:</strong> Eredeti és kiváló minőségű alternatívák</li>
        <li><strong>Fékcsövek:</strong> Megerősített változatok a hosszú élettartamhoz</li>
      </ul>
      
      <h3>Gyakran feltett kérdések</h3>
      <p><strong>Milyen gyakran kell cserélni a fékbetéteket?</strong><br>
      Általában 30.000-70.000 km-enként, vezetési stílustól és körülményektől függően.</p>
      
      <p><strong>Hogyan ismerem fel az elhasználódott féktárcsákat?</strong><br>
      Sípoló hangok fékezéskor, rezgés a kormányban vagy meghosszabbodott féktávolság egyértelmű jelek.</p>
      
      <p><strong>Szakértői tanácsadás:</strong> Hívjon minket, és megtaláljuk a megfelelő fékkomponenseket járműve számára – garantáltan kompatibilis és a legjobb ár-érték arányban.</p>
    `,
    keywords: ['Féktárcsák', 'Fékbetétek', 'Fékfolyadék', 'Féknyergek', 'Fékcsövek']
  },
  filters: {
    title: 'Szűrők az optimális motorteljesítményhez',
    intro: 'Légszűrők, olajszűrők, üzemanyagszűrők – tiszta égéshez és hosszú motor-élettartamhoz.',
    content: `
      <h3>A rendszeres szűrőcsere fontossága</h3>
      <p>A szűrők a járműve "veséi". Távol tartják a szennyeződéseket és biztosítják, hogy a motor és az üzemanyagrendszer kifogástalanul működjön. A kellő időben történő csere üzemanyagot takarít meg és megelőzi a költséges javításokat.</p>
      
      <h3>Szűrő kínálatunk</h3>
      <ul>
        <li><strong>Légszűrők:</strong> Standard és sport légszűrők jobb teljesítményhez</li>
        <li><strong>Olajszűrők:</strong> Minden motortípushoz, szintetikus olajokhoz is</li>
        <li><strong>Üzemanyagszűrők:</strong> Benzin és dízel, modern közvetlen befecskendezéshez is</li>
        <li><strong>Utastér szűrők:</strong> Aktív szénnel és anélkül tiszta levegőhöz</li>
        <li><strong>Váltóolaj szűrők:</strong> Automata váltókhoz</li>
      </ul>
      
      <h3>Gyakran feltett kérdések</h3>
      <p><strong>Milyen gyakran kell cserélni a légszűrőt?</strong><br>
      Általában 15.000-30.000 km-enként vagy évente egyszer.</p>
      
      <p><strong>Mi történik egy eltömődött üzemanyagszűrőnél?</strong><br>
      A motor rángatózhat, teljesítményt veszíthet vagy legrosszabb esetben egyáltalán nem indul.</p>
    `,
    keywords: ['Légszűrő', 'Olajszűrő', 'Üzemanyagszűrő', 'Utastér szűrő', 'Váltóolaj szűrő']
  },
  chassis: {
    title: 'Futómű komponensek a biztonságos vezetéshez',
    intro: 'Lengéscsillapítók, rugók, lengőkarok – kényelemért és vezetési biztonságért.',
    content: `
      <h3>Az ép futómű elengedhetetlen</h3>
      <p>A futómű köti össze járművét az úttal. Az elhasználódott alkatrészek nemcsak a vezetési kényelmet, hanem a biztonságot is befolyásolják. Kiváló minőségű futómű alkatrészeket szállítunk, amelyek tökéletesen illenek járművéhez.</p>
      
      <h3>Futómű komponenseink</h3>
      <ul>
        <li><strong>Lengéscsillapítók:</strong> Gáz és olaj csillapítók minden járműtípushoz</li>
        <li><strong>Rugók:</strong> Eredeti rugók és sport rugók</li>
        <li><strong>Lengőkarok:</strong> Komplett persellyel és gömbcsuklóval</li>
        <li><strong>Stabilizátorok:</strong> Jobb kanyarodási viselkedéshez</li>
        <li><strong>Tengelycsapok és kerékcsapágyak:</strong> Első felszerelői minőségben</li>
      </ul>
    `,
    keywords: ['Lengéscsillapítók', 'Rugók', 'Lengőkarok', 'Stabilizátorok', 'Kerékcsapágyak']
  },
  electrical: {
    title: 'Elektromos alkatrészek a megbízhatóságért',
    intro: 'Akkumulátorok, indítómotorok, generátorok – hogy járműve mindig induljon.',
    content: `
      <h3>Elektromos rendszerek – a modern járművek szíve</h3>
      <p>Működő elektromos rendszer nélkül semmi sem működik. Az akkumulátortól az indítómotoron át a generátorig – megbízható alkatrészeket kínálunk járműve összes elektromos rendszeréhez.</p>
      
      <h3>Elektromos kínálatunk</h3>
      <ul>
        <li><strong>Indító akkumulátorok:</strong> AGM, EFB és ólom-savas akkumulátorok</li>
        <li><strong>Indítómotorok:</strong> Benzin és dízel motorokhoz</li>
        <li><strong>Generátorok:</strong> Eredeti és felújított minőség</li>
        <li><strong>Gyújtógyertyák:</strong> Réz, platina és irídium</li>
        <li><strong>Érzékelők:</strong> Lambda szondák, ABS érzékelők, főtengely érzékelők, vezérműtengely érzékelő, kipufogógáz hőmérséklet érzékelő, differenciálnyomás érzékelő, NOX-érzékelő, olajnyomás érzékelő, hűtővíz hőmérséklet érzékelő, töltőnyomás érzékelő, szívócső nyomás érzékelő</li>
      </ul>
    `,
    keywords: ['Akkumulátor', 'Indítómotor', 'Generátor', 'Gyújtógyertyák', 'Érzékelők']
  },
  lighting: {
    title: 'Világítás a biztonságért és láthatóságért',
    intro: 'Fényszórók, hátsó lámpák, LED technológia – optimális láthatóságért nappal és éjjel.',
    content: `
      <h3>Látni és látszani</h3>
      <p>A működő világítás törvényi előírás és létfontosságú. Minden típusú izzót és világítási komponenst vezetünk járművéhez.</p>
      
      <h3>Világítási kínálatunk</h3>
      <ul>
        <li><strong>Fényszórók:</strong> Halogén, xenon és LED fényszórók</li>
        <li><strong>Izzók:</strong> H1, H4, H7 és minden elterjedt típus</li>
        <li><strong>Hátsó lámpák:</strong> Eredeti és tuning változatok</li>
        <li><strong>Ködlámpák:</strong> Jobb láthatóságért rossz időben</li>
        <li><strong>Belső világítás:</strong> LED átalakító készletek</li>
      </ul>
    `,
    keywords: ['Fényszórók', 'Izzók', 'Hátsó lámpák', 'LED', 'Xenon']
  },
  exhaust: {
    title: 'Kipufogórendszerek teljesítményhez és környezetvédelemhez',
    intro: 'Kipufogó dobok, katalizátorok, kipufogócsövek – tiszta kipufogógázért és optimális teljesítményért.',
    content: `
      <h3>A kipufogórendszer – több mint zajcsillapítás</h3>
      <p>Az ép kipufogórendszer nemcsak a zajt csökkenti, hanem a szennyeződéseket is és befolyásolja a motorteljesítményt. Komplett rendszereket és egyes alkatrészeket kínálunk a legjobb minőségben.</p>
      
      <h3>Kipufogó kínálatunk</h3>
      <ul>
        <li><strong>Hátsó dobok:</strong> Eredeti és sport kipufogó</li>
        <li><strong>Katalizátorok:</strong> Fém és kerámia katalizátorok</li>
        <li><strong>Középső dobok:</strong> Minden járműtípushoz</li>
        <li><strong>Részecskeszűrők:</strong> Dízel járművekhez</li>
        <li><strong>Kipufogócsövek és bilincsek:</strong> Rozsdamentes minőség</li>
      </ul>
    `,
    keywords: ['Hátsó dob', 'Katalizátor', 'Részecskeszűrő', 'Kipufogócső', 'Sport kipufogó']
  },
  clutch: {
    title: 'Kuplungok a sima sebességváltáshoz',
    intro: 'Kuplung készletek, kioldócsapágyak, lendkerekek – tökéletes kapcsoláshoz.',
    content: `
      <h3>A kuplung – a kapcsolat a motor és a váltó között</h3>
      <p>Az elhasználódott kuplung csúszással, nehéz kapcsolással vagy zajokkal jelentkezik. Komplett kuplung készleteket és egyes alkatrészeket szállítunk minden járműhöz.</p>
      
      <h3>Kuplung kínálatunk</h3>
      <ul>
        <li><strong>Kuplung készletek:</strong> 3 részes nyomólappal, tárcsával és kioldócsapággyal</li>
        <li><strong>Kéttömegű lendkerekek:</strong> Eredeti és megerősített változatok</li>
        <li><strong>Kioldó rendszerek:</strong> Hidraulikus és mechanikus</li>
        <li><strong>Kuplung tárcsák:</strong> Standard és nagy nyomatékhoz</li>
        <li><strong>Főhengerek:</strong> Hidraulikus kuplungokhoz</li>
      </ul>
    `,
    keywords: ['Kuplung készlet', 'Kéttömegű lendkerék', 'Kioldócsapágy', 'Kuplung tárcsa', 'Központi kioldócsapágy', 'Főhenger', 'Munkahenger']
  },
  engine: {
    title: 'Motor alkatrészek teljesítményhez és megbízhatósághoz',
    intro: 'Hengerfej tömítések, vezérlőláncok, vízpumpák – egészséges motorhoz.',
    content: `
      <h3>A motor – járműve szíve</h3>
      <p>A motor alkatrészeinek a legnagyobb terheléseket kell kibírniuk. Első felszerelői minőségű pótalkatrészeket kínálunk, amelyek garantálják a hosszú élettartamot és teljesítményt.</p>
      
      <h3>Motor kínálatunk</h3>
      <ul>
        <li><strong>Hengerfej tömítések:</strong> Minden motortípushoz</li>
        <li><strong>Vezérlőláncok és szíjak:</strong> OEM minőségben, vagy olcsóbban márkagyártóktól költséghatékony javításhoz</li>
        <li><strong>Vízpumpák:</strong> Mechanikus, kapcsolható vagy tisztán elektromos vízpumpák</li>
        <li><strong>Dugattyúk és hajtórudak:</strong> Standard és megerősített változatok</li>
        <li><strong>Vezérműtengelyek:</strong> Eredeti és teljesítmény változatok</li>
        <li><strong>Adalékanyagok:</strong> Hidraulikus emelő adalék, befecskendező rendszer tisztító, ólom-helyettesítő veterán motorokhoz, visco-adalék olajfogyasztás ellen</li>
        <li><strong>Szelepek:</strong> Szívó- és kipufogószelepek, szeleptőtömítések OEM minőségben</li>
        <li><strong>Olajteknő:</strong> Az acél teknők idővel rozsdásodnak, gyakori probléma a műszaki vizsgákon</li>
        <li><strong>Tömítőgyűrűk:</strong> pl. főtengely tömítőgyűrűk gyakran olajszivárgást okoznak és szintén gyakori probléma a műszaki vizsgákon</li>
        <li><strong>Termosztát:</strong> optimális hűtést biztosít a motornak, de meleg utasteret is télen</li>
      </ul>
    `,
    keywords: ['Hengerfej tömítés', 'Fogasszíj', 'Vezérlőlánc', 'Vízpumpa', 'Dugattyúk', 'Tömítőgyűrű', 'Szelep', 'Termosztát', 'Adalékanyag', 'Olajfogyasztás']
  },
  body: {
    title: 'Karosszéria alkatrészek megjelenéshez és funkcióhoz',
    intro: 'Tükrök, ajtókilincsek, lökhárítók – tökéletes megjelenéshez.',
    content: `
      <h3>Karosszéria alkatrészek – formához és funkcióhoz</h3>
      <p>A sérült vagy elhasználódott karosszéria alkatrészek nemcsak a megjelenést, hanem a funkcionalitást is befolyásolják. Minden járműmodellhez illő pótalkatrészeket szállítunk.</p>
      
      <h3>Karosszéria kínálatunk</h3>
      <ul>
        <li><strong>Külső tükrök:</strong> Komplett vagy egyes tükörüvegek</li>
        <li><strong>Tükörüveg:</strong> Csere üvegek különböző járműmodellekhez</li>
        <li><strong>Ajtókilincsek:</strong> Belső és külső</li>
        <li><strong>Lökhárítók:</strong> Alapozott vagy festett</li>
        <li><strong>Sárvédők:</strong> Eredeti és utángyártott</li>
        <li><strong>Küszöb / Belépő:</strong> Javító lemezek és pótalkatrészek</li>
        <li><strong>Javító lemez sárvédőkhöz:</strong> Precíz karosszéria javításokhoz</li>
        <li><strong>Díszlécek:</strong> Króm és műanyag</li>
      </ul>
    `,
    keywords: ['Külső tükrök', 'Ajtókilincsek', 'Lökhárítók', 'Sárvédők', 'Díszlécek', 'Tükörüveg', 'Küszöb', 'Javító lemez']
  },
  drivetrain: {
    title: 'Hajtáslánc alkatrészek erőteljes erőátvitelhez',
    intro: 'Hajtótengelyek, csuklók, kardántengelyek – biztonságos erőátvitelhez a kerekekhez.',
    content: `
      <h3>A hajtáslánc – az erőátvitel szíve</h3>
      <p>A hajtáslánc továbbítja a motor teljesítményét a kerekekhez. A kopás vagy hibák rezgésekhez, zajokhoz vezetnek és ronthatják a vezetési biztonságot. Kiváló minőségű hajtáslánc alkatrészeket szállítunk OEM minőségben.</p>
      
      <h3>Hajtáslánc kínálatunk</h3>
      <ul>
        <li><strong>Hajtótengelyek:</strong> Komplett csuklókkal és védőgumikkal</li>
        <li><strong>Csuklók:</strong> Első-, hátsó- és összkerékhajtáshoz</li>
        <li><strong>Kardántengelyek:</strong> Hátsó- és összkerékhajtású járművekhez</li>
        <li><strong>CV-csuklók:</strong> Homokinetikus csuklók egyenletes futáshoz</li>
        <li><strong>Hajtótengely védőgumik:</strong> Megbízható csukló védelemhez</li>
        <li><strong>Kardántengely csapágyak:</strong> Rezgésmentes futáshoz</li>
      </ul>
      
      <h3>Gyakran feltett kérdések</h3>
      <p><strong>Hogyan ismerem fel a hibás hajtótengelyt?</strong><br>
      Tipikus tünetek a kattogó hangok kormányzáskor, rezgések gyorsításkor vagy láthatóan sérült védőgumik.</p>
      
      <p><strong>Javíthatók a hajtótengelyek?</strong><br>
      A legtöbb esetben a csere gazdaságosabb és biztonságosabb, mint a javítás.</p>
      
      <p><strong>Milyen gyakran kell ellenőrizni a hajtótengely védőgumikat?</strong><br>
      A védőgumikat minden vizsgálatnál ellenőrizni kell repedések és sérülések szempontjából.</p>
      
      <p><strong>Bízzon tapasztalatunkban:</strong> Megtaláljuk a megfelelő hajtáslánc alkatrészeket járművéhez – akár első-, hátsó- vagy összkerékhajtásról van szó.</p>
    `,
    keywords: ['Hajtótengely', 'Csukló', 'Kardántengely', 'CV-csukló', 'Homokinetikus', 'Védőgumi']
  },
  climate: {
    title: 'Klíma és fűtés a tökéletes hőmérséklethez',
    intro: 'Klímakompresszorok, fűtőventilátorok, hűtők – kényelmes klímáért a járműben.',
    content: `
      <h3>Klíma és fűtő rendszerek – kényelem minden évszakban</h3>
      <p>A működő klíma és fűtés kellemes hőmérsékletet és tiszta kilátást biztosít. Minden alkatrészt szállítunk klímarendszeréhez.</p>
      
      <h3>Klíma kínálatunk</h3>
      <ul>
        <li><strong>Klímakompresszorok:</strong> Eredeti és kiváló minőségű alternatívák</li>
        <li><strong>Kondenzátorok:</strong> Hatékony hűtéshez</li>
        <li><strong>Fűtőventilátorok:</strong> Meleg levegőhöz télen</li>
        <li><strong>Fűtőventilátor ellenállás:</strong> amikor a ventilátor fokozatai nem kapcsolnak át</li>
        <li><strong>Hűtőfolyadék hűtők:</strong> Optimális motor hőmérséklethez</li>
        <li><strong>Szárítók és szűrők:</strong> Tiszta klímarendszerekhez</li>
      </ul>
    `,
    keywords: ['Klímakompresszor', 'Kondenzátor', 'Fűtőventilátor', 'Hűtő', 'Klíma szerviz']
  },
  others: {
    title: 'További autóalkatrészek és kiegészítők',
    intro: 'Minden más, amire szüksége van – ablaktörlőktől a vonóhorgokig.',
    content: `
      <h3>Átfogó kínálat minden igényhez</h3>
      <p>A főkategóriák mellett széles választékú további autóalkatrészt és kiegészítőt vezetünk. Bármit keres – megvan vagy beszerezzük.</p>
      
      <h3>További termékek</h3>
      <ul>
        <li><strong>Ablaktörlő lapátok:</strong> Minden hosszban és típusban</li>
        <li><strong>Gumiabroncsok:</strong> Nyári, téli és négyévszakos gumiabroncsok</li>
        <li><strong>Vonóhorgok:</strong> Fix és levehető</li>
        <li><strong>Tömítések:</strong> Ajtókhoz, ablakokhoz és csomagtartóhoz</li>
        <li><strong>Ápolószerek:</strong> Motorolaj, fagyálló, tisztítók</li>
        <li><strong>Gumiabroncs nyomásérzékelő:</strong> Modern TPMS-sel rendelkező járművekhez</li>
        <li><strong>Fényezőszer:</strong> Fényes lakkápoláshoz</li>
        <li><strong>Fényszóró tömítés / fényezés:</strong> Tiszta kilátáshoz és ápolt megjelenéshez</li>
        <li><strong>Szélvédőmosó / téli fagyálló:</strong> Tiszta kilátáshoz fagyos hőmérsékleten</li>
        <li><strong>Szélvédő takaró / félgarázs:</strong> Védelem az időjárástól</li>
      </ul>
    `,
    keywords: ['Ablaktörlő lapátok', 'Gumiabroncsok', 'Vonóhorog', 'Ápolószerek', 'Kiegészítők', 'Gumiabroncs nyomásérzékelő', 'Fényezőszer', 'Szélvédő fagyálló']
  }
};

export const categoryDetailsPL = {
  brakes: {
    title: 'Komponenty hamulcowe dla wszystkich pojazdów',
    intro: 'Wysokiej jakości tarcze hamulcowe, klocki hamulcowe i kompletne systemy hamulcowe dla maksymalnego bezpieczeństwa.',
    content: `
      <h3>Dlaczego wysokiej jakości hamulce są tak ważne?</h3>
      <p>Układ hamulcowy to najważniejszy element bezpieczeństwa pojazdu. Zużyte lub niskiej jakości komponenty hamulcowe mogą prowadzić do niebezpiecznych sytuacji. W Autoteile Flott oferujemy tylko sprawdzoną jakość marek, która spełnia najwyższe standardy bezpieczeństwa.</p>
      
      <h3>Przegląd naszych komponentów hamulcowych</h3>
      <ul>
        <li><strong>Tarcze hamulcowe:</strong> Wersje perforowane i nacięte dla optymalnej wydajności hamowania</li>
        <li><strong>Klocki hamulcowe:</strong> Warianty organiczne i metaliczne dla różnych stylów jazdy</li>
        <li><strong>Płyn hamulcowy:</strong> DOT 3, DOT 4 i DOT 5.1 dla wszystkich wymagań</li>
        <li><strong>Zaciski hamulcowe:</strong> Oryginalne i wysokiej jakości alternatywy</li>
        <li><strong>Przewody hamulcowe:</strong> Wzmocnione wersje dla długiej żywotności</li>
      </ul>
      
      <h3>Często zadawane pytania</h3>
      <p><strong>Jak często należy wymieniać klocki hamulcowe?</strong><br>
      Zwykle co 30 000-70 000 km, w zależności od stylu jazdy i warunków.</p>
      
      <p><strong>Jak rozpoznać zużyte tarcze hamulcowe?</strong><br>
      Piszczące dźwięki podczas hamowania, wibracje w kierownicy lub przedłużone drogi hamowania to wyraźne oznaki.</p>
      
      <p><strong>Fachowe doradztwo:</strong> Zadzwoń do nas, a znajdziemy odpowiednie komponenty hamulcowe dla Twojego pojazdu – gwarantowana kompatybilność i najlepszy stosunek ceny do jakości.</p>
    `,
    keywords: ['Tarcze hamulcowe', 'Klocki hamulcowe', 'Płyn hamulcowy', 'Zaciski hamulcowe', 'Przewody hamulcowe']
  },
  filters: {
    title: 'Filtry dla optymalnej wydajności silnika',
    intro: 'Filtry powietrza, filtry oleju, filtry paliwa – dla czystego spalania i długiej żywotności silnika.',
    content: `
      <h3>Znaczenie regularnej wymiany filtrów</h3>
      <p>Filtry to "nerki" pojazdu. Zatrzymują brud, kurz i zanieczyszczenia oraz zapewniają prawidłowe działanie silnika i układu paliwowego. Terminowa wymiana oszczędza paliwo i zapobiega kosztownym naprawom.</p>
      
      <h3>Nasza oferta filtrów</h3>
      <ul>
        <li><strong>Filtry powietrza:</strong> Standardowe i sportowe filtry powietrza dla lepszej wydajności</li>
        <li><strong>Filtry oleju:</strong> Dla wszystkich typów silników, również syntetycznych olejów</li>
        <li><strong>Filtry paliwa:</strong> Benzyna i diesel, również dla nowoczesnych wtryskiwaczy bezpośrednich</li>
        <li><strong>Filtry kabinowe:</strong> Z węglem aktywnym i bez dla czystego powietrza</li>
        <li><strong>Filtry oleju przekładniowego:</strong> Dla automatycznych skrzyń biegów</li>
      </ul>
      
      <h3>Często zadawane pytania</h3>
      <p><strong>Jak często należy wymieniać filtr powietrza?</strong><br>
      Zwykle co 15 000-30 000 km lub raz w roku.</p>
      
      <p><strong>Co się dzieje przy zakorkowanym filtrze paliwa?</strong><br>
      Silnik może szarpać, tracić moc lub w najgorszym przypadku w ogóle nie uruchomić się.</p>
    `,
    keywords: ['Filtr powietrza', 'Filtr oleju', 'Filtr paliwa', 'Filtr kabinowy', 'Filtr oleju przekładniowego']
  },
  chassis: {
    title: 'Komponenty podwozia dla bezpiecznej jazdy',
    intro: 'Amortyzatory, sprężyny, wahacze – dla komfortu i bezpieczeństwa jazdy.',
    content: `
      <h3>Sprawne podwozie jest niezbędne</h3>
      <p>Podwozie łączy pojazd z drogą. Zużyte komponenty wpływają nie tylko na komfort jazdy, ale także na bezpieczeństwo. Dostarczamy wysokiej jakości części podwozia, które idealnie pasują do pojazdu.</p>
      
      <h3>Nasze komponenty podwozia</h3>
      <ul>
        <li><strong>Amortyzatory:</strong> Gazowe i olejowe dla wszystkich typów pojazdów</li>
        <li><strong>Sprężyny:</strong> Oryginalne sprężyny i sprężyny sportowe</li>
        <li><strong>Wahacze:</strong> Kompletne z tuleiami i przegubami kulowymi</li>
        <li><strong>Stabilizatory:</strong> Dla lepszego zachowania w zakrętach</li>
        <li><strong>Zwrotnice i łożyska kół:</strong> W jakości OEM</li>
      </ul>
    `,
    keywords: ['Amortyzatory', 'Sprężyny', 'Wahacze', 'Stabilizatory', 'Łożyska kół']
  },
  electrical: {
    title: 'Komponenty elektryczne dla niezawodności',
    intro: 'Akumulatory, rozruszniki, alternatory – aby pojazd zawsze się uruchamiał.',
    content: `
      <h3>Układy elektryczne – serce nowoczesnych pojazdów</h3>
      <p>Bez działającej elektryki nic nie działa. Od akumulatora przez rozrusznik po alternator – oferujemy niezawodne komponenty dla wszystkich układów elektrycznych pojazdu.</p>
      
      <h3>Nasza oferta elektryczna</h3>
      <ul>
        <li><strong>Akumulatory rozruchowe:</strong> Akumulatory AGM, EFB i kwasowo-ołowiowe</li>
        <li><strong>Rozruszniki:</strong> Dla silników benzynowych i diesla</li>
        <li><strong>Alternatory:</strong> Jakość oryginalna i odnowiona</li>
        <li><strong>Świece zapłonowe:</strong> Miedziane, platynowe i irydowe</li>
        <li><strong>Czujniki:</strong> Sondy lambda, czujniki ABS, czujniki wału korbowego, czujnik wałka rozrządu, czujnik temperatury spalin, czujnik ciśnienia różnicowego, czujnik NOX, czujnik ciśnienia oleju, czujnik temperatury płynu chłodzącego, czujnik ciśnienia doładowania, czujnik ciśnienia kolektora ssącego</li>
      </ul>
    `,
    keywords: ['Akumulator', 'Rozrusznik', 'Alternator', 'Świece zapłonowe', 'Czujniki']
  },
  lighting: {
    title: 'Oświetlenie dla bezpieczeństwa i widoczności',
    intro: 'Reflektory, światła tylne, technologia LED – dla optymalnej widoczności w dzień i w nocy.',
    content: `
      <h3>Widzieć i być widzianym</h3>
      <p>Działające oświetlenie jest wymagane prawem i niezbędne dla życia. Prowadzimy wszystkie typy żarówek i komponentów oświetleniowych dla pojazdu.</p>
      
      <h3>Nasza oferta oświetlenia</h3>
      <ul>
        <li><strong>Reflektory:</strong> Reflektory halogenowe, ksenonowe i LED</li>
        <li><strong>Żarówki:</strong> H1, H4, H7 i wszystkie popularne typy</li>
        <li><strong>Światła tylne:</strong> Oryginalne i wersje tuningowe</li>
        <li><strong>Światła przeciwmgielne:</strong> Dla lepszej widoczności w złej pogodzie</li>
        <li><strong>Oświetlenie wewnętrzne:</strong> Zestawy do konwersji LED</li>
      </ul>
    `,
    keywords: ['Reflektory', 'Żarówki', 'Światła tylne', 'LED', 'Ksenon']
  },
  exhaust: {
    title: 'Układy wydechowe dla wydajności i środowiska',
    intro: 'Tłumiki, katalizatory, rury wydechowe – dla czystych spalin i optymalnej wydajności.',
    content: `
      <h3>Układ wydechowy – więcej niż tylko tłumienie hałasu</h3>
      <p>Sprawny układ wydechowy nie tylko redukuje hałas, ale także zanieczyszczenia i wpływa na wydajność silnika. Oferujemy kompletne systemy i pojedyncze komponenty w najlepszej jakości.</p>
      
      <h3>Nasza oferta układów wydechowych</h3>
      <ul>
        <li><strong>Tłumiki końcowe:</strong> Oryginalne i sportowe układy wydechowe</li>
        <li><strong>Katalizatory:</strong> Katalizatory metalowe i ceramiczne</li>
        <li><strong>Tłumiki środkowe:</strong> Dla wszystkich typów pojazdów</li>
        <li><strong>Filtry cząstek stałych:</strong> Dla pojazdów diesla</li>
        <li><strong>Rury wydechowe i obejmy:</strong> Jakość nierdzewna</li>
      </ul>
    `,
    keywords: ['Tłumik końcowy', 'Katalizator', 'Filtr cząstek', 'Rura wydechowa', 'Sportowy wydech']
  },
  clutch: {
    title: 'Sprzęgła dla płynnej zmiany biegów',
    intro: 'Zestawy sprzęgła, łożyska wyciskowe, koła zamachowe – dla idealnego przełączania.',
    content: `
      <h3>Sprzęgło – połączenie między silnikiem a skrzynią biegów</h3>
      <p>Zużyte sprzęgło objawia się poślizgiem, trudnym przełączaniem lub hałasami. Dostarczamy kompletne zestawy sprzęgła i pojedyncze komponenty dla wszystkich pojazdów.</p>
      
      <h3>Nasza oferta sprzęgieł</h3>
      <ul>
        <li><strong>Zestawy sprzęgła:</strong> 3-częściowe z płytą dociskową, tarczą i łożyskiem</li>
        <li><strong>Dwumasowe koła zamachowe:</strong> Oryginalne i wzmocnione wersje</li>
        <li><strong>Systemy wyciskowe:</strong> Hydrauliczne i mechaniczne</li>
        <li><strong>Tarcze sprzęgła:</strong> Standardowe i dla wysokich momentów obrotowych</li>
        <li><strong>Pompy główne:</strong> Dla sprzęgieł hydraulicznych</li>
      </ul>
    `,
    keywords: ['Zestaw sprzęgła', 'Dwumasowe koło zamachowe', 'Łożysko wyciskowe', 'Tarcza sprzęgła', 'Centralne łożysko wyciskowe', 'Pompa główna', 'Pompa robocza']
  },
  engine: {
    title: 'Komponenty silnika dla wydajności i niezawodności',
    intro: 'Uszczelki głowicy, łańcuchy rozrządu, pompy wody – dla zdrowego silnika.',
    content: `
      <h3>Silnik – serce pojazdu</h3>
      <p>Komponenty silnika muszą wytrzymać najwyższe obciążenia. Oferujemy części zamienne w jakości OEM, które gwarantują długą żywotność i wydajność.</p>
      
      <h3>Nasza oferta silnikowa</h3>
      <ul>
        <li><strong>Uszczelki głowicy:</strong> Dla wszystkich typów silników</li>
        <li><strong>Łańcuchy i paski rozrządu:</strong> W jakości OEM lub taniej od producentów markowych do ekonomicznej naprawy</li>
        <li><strong>Pompy wody:</strong> Mechaniczne, przełączalne lub całkowicie elektryczne pompy wody</li>
        <li><strong>Tłoki i korbowody:</strong> Standardowe i wzmocnione wersje</li>
        <li><strong>Wałki rozrządu:</strong> Oryginalne i wersje wydajnościowe</li>
        <li><strong>Dodatki:</strong> Dodatek do popychaczy hydraulicznych, czyszczenie układu wtryskowego, zamiennik ołowiu do silników klasycznych, dodatek visco przeciw zużyciu oleju</li>
        <li><strong>Zawory:</strong> Zawory dolotowe i wydechowe, uszczelki trzonków zaworów w jakości OEM</li>
        <li><strong>Miska olejowa:</strong> Stalowe miski rdzewiją z czasem, częsty problem przy przeglądach technicznych</li>
        <li><strong>Pierścienie uszczelniające:</strong> np. pierścienie uszczelniające wału korbowego często powodują wyciek oleju i również są częstym problemem przy przeglądach technicznych</li>
        <li><strong>Termostat:</strong> zapewnia optymalne chłodzenie silnika, ale także ciepłe wnętrze zimą</li>
      </ul>
    `,
    keywords: ['Uszczelka głowicy', 'Pasek rozrządu', 'Łańcuch rozrządu', 'Pompa wody', 'Tłoki', 'Pierścień uszczelniający', 'Zawór', 'Termostat', 'Dodatek', 'Zużycie oleju']
  },
  body: {
    title: 'Części nadwozia dla wyglądu i funkcji',
    intro: 'Lusterka, klamki, zderzaki – dla idealnego wyglądu.',
    content: `
      <h3>Części nadwozia – dla formy i funkcji</h3>
      <p>Uszkodzone lub zużyte części nadwozia wpływają nie tylko na wygląd, ale także na funkcjonalność. Dostarczamy pasujące części zamienne dla wszystkich modeli pojazdów.</p>
      
      <h3>Nasza oferta nadwozia</h3>
      <ul>
        <li><strong>Lusterka boczne:</strong> Kompletne lub pojedyncze szkła lusterek</li>
        <li><strong>Szkło lusterka:</strong> Wymienne szkła do różnych modeli pojazdów</li>
        <li><strong>Klamki:</strong> Wewnętrzne i zewnętrzne</li>
        <li><strong>Zderzaki:</strong> Podkładowane lub malowane</li>
        <li><strong>Błotniki:</strong> Oryginalne i aftermarket</li>
        <li><strong>Progi / Wejście:</strong> Blachy naprawcze i części zamienne</li>
        <li><strong>Blacha naprawcza do błotników:</strong> Do precyzyjnych napraw nadwozia</li>
        <li><strong>Listwy ozdobne:</strong> Chromowane i plastikowe</li>
      </ul>
    `,
    keywords: ['Lusterka boczne', 'Klamki', 'Zderzaki', 'Błotniki', 'Listwy ozdobne', 'Szkło lusterka', 'Progi', 'Blacha naprawcza']
  },
  drivetrain: {
    title: 'Komponenty napędu dla mocnego przenoszenia mocy',
    intro: 'Półosie, przeguby, wały napędowe – dla bezpiecznego przenoszenia mocy na koła.',
    content: `
      <h3>Napęd – serce przenoszenia mocy</h3>
      <p>Układ napędowy przenosi moc silnika na koła. Zużycie lub usterki prowadzą do wibracji, hałasów i mogą pogorszyć bezpieczeństwo jazdy. Dostarczamy wysokiej jakości komponenty napędowe w jakości OEM.</p>
      
      <h3>Nasza oferta napędu</h3>
      <ul>
        <li><strong>Półosie:</strong> Kompletne z przegubami i osłonami</li>
        <li><strong>Przeguby:</strong> Dla napędu przedniego, tylnego i na wszystkie koła</li>
        <li><strong>Wały napędowe:</strong> Dla pojazdów z napędem tylnym i na wszystkie koła</li>
        <li><strong>Przeguby CV:</strong> Przeguby homokinetyczne dla płynnego biegu</li>
        <li><strong>Osłony półosi:</strong> Dla niezawodnej ochrony przegubów</li>
        <li><strong>Łożyska wałów napędowych:</strong> Dla biegu bez wibracji</li>
      </ul>
      
      <h3>Często zadawane pytania</h3>
      <p><strong>Jak rozpoznać uszkodzoną półoś?</strong><br>
      Typowe objawy to klikające odgłosy podczas skręcania, wibracje podczas przyspieszania lub widocznie uszkodzone osłony.</p>
      
      <p><strong>Czy można naprawić półosie?</strong><br>
      W większości przypadków wymiana jest bardziej ekonomiczna i bezpieczniejsza niż naprawa.</p>
      
      <p><strong>Jak często należy sprawdzać osłony półosi?</strong><br>
      Osłony należy sprawdzać pod kątem pęknięć i uszkodzeń przy każdym przeglądzie.</p>
      
      <p><strong>Zaufaj naszemu doświadczeniu:</strong> Znajdziemy odpowiednie komponenty napędowe dla Twojego pojazdu – czy to napęd przedni, tylny czy na wszystkie koła.</p>
    `,
    keywords: ['Półoś', 'Przegub', 'Wał napędowy', 'Przegub CV', 'Homokinetyczny', 'Osłona']
  },
  climate: {
    title: 'Klimatyzacja i ogrzewanie dla idealnej temperatury',
    intro: 'Sprężarki klimatyzacji, dmuchawy ogrzewania, chłodnice – dla komfortowego klimatu w pojeździe.',
    content: `
      <h3>Systemy klimatyzacji i ogrzewania – komfort o każdej porze roku</h3>
      <p>Działająca klimatyzacja i ogrzewanie zapewniają przyjemne temperatury i czystą widoczność. Dostarczamy wszystkie komponenty dla systemu klimatyzacji.</p>
      
      <h3>Nasza oferta klimatyzacji</h3>
      <ul>
        <li><strong>Sprężarki klimatyzacji:</strong> Oryginalne i wysokiej jakości alternatywy</li>
        <li><strong>Skraplacze:</strong> Dla wydajnego chłodzenia</li>
        <li><strong>Dmuchawy ogrzewania:</strong> Dla ciepłego powietrza zimą</li>
        <li><strong>Opornik dmuchawy ogrzewania:</strong> gdy poziomy wentylatora nie przełączają się</li>
        <li><strong>Chłodnice płynu chłodzącego:</strong> Dla optymalnej temperatury silnika</li>
        <li><strong>Osuszacze i filtry:</strong> Dla czystych systemów klimatyzacji</li>
      </ul>
    `,
    keywords: ['Sprężarka klimatyzacji', 'Skraplacz', 'Dmuchawa ogrzewania', 'Chłodnica', 'Serwis klimatyzacji']
  },
  others: {
    title: 'Inne części samochodowe i akcesoria',
    intro: 'Wszystko inne, czego potrzebujesz – od wycieraczek po haki holownicze.',
    content: `
      <h3>Kompleksowa oferta dla wszystkich potrzeb</h3>
      <p>Oprócz głównych kategorii prowadzimy szeroki wybór innych części samochodowych i akcesoriów. Cokolwiek szukasz – mamy to lub możemy to zdobyć dla Ciebie.</p>
      
      <h3>Inne produkty</h3>
      <ul>
        <li><strong>Wycieraczki:</strong> Wszystkie długości i typy</li>
        <li><strong>Opony:</strong> Opony letnie, zimowe i całoroczne</li>
        <li><strong>Haki holownicze:</strong> Stałe i zdejmowane</li>
        <li><strong>Uszczelki:</strong> Dla drzwi, okien i bagażnika</li>
        <li><strong>Produkty pielęgnacyjne:</strong> Olej silnikowy, płyn niezamarzający, środki czyszczące</li>
        <li><strong>Czujnik ciśnienia w oponach:</strong> Dla nowoczesnych pojazdów z TPMS</li>
        <li><strong>Środki polerskie:</strong> Do lśniącej pielęgnacji lakieru</li>
        <li><strong>Uszczelnienie / politura reflektorów:</strong> Dla czystej widoczności i zadbać wyglądu</li>
        <li><strong>Płyn do spryskiwaczy / zimowy płyn niezamarzający:</strong> Dla czystej widoczności w mroźnych temperaturach</li>
        <li><strong>Pokrowce na szybę czołową / półgaraże:</strong> Ochrona przed warunkami atmosferycznymi</li>
      </ul>
    `,
    keywords: ['Wycieraczki', 'Opony', 'Hak holowniczy', 'Produkty pielęgnacyjne', 'Akcesoria', 'Czujnik ciśnienia w oponach', 'Środki polerskie', 'Zimowy płyn niezamarzający']
  }
};
